import { PrepaymentErrors } from "apollo/data"



export const usePrepaymentErrors = (variables?: any) => {
    const { page, pageSize, search } = variables || { page: 1, pageSize: 10, search: "" };
    const start = (parseInt(page) - 1) * pageSize;
    const end = start + pageSize;
    const items = PrepaymentErrors.filter(el => {
        return el.code.toLowerCase().includes(search.toLowerCase()) ||
            el.description.toLowerCase().includes(search.toLowerCase())
    }).slice(start, end);
    return {
        reasons: items,
        count: PrepaymentErrors.filter(el => {
            return el.code.toLowerCase().includes(search.toLowerCase()) ||
                el.description.toLowerCase().includes(search.toLowerCase())
        }).length
    }
}